<div class="radio-group" *ngIf="showAvailabilityFilter">
  <p class="show-title">{{'sidebar.filters.show' | translate}}</p>
  <fieldset>
    <legend hidden>{{'general.show.result' | translate}}</legend>
    <mat-radio-group
      [attr.aria-label]="'general.selectAnOption' | translate"
      [(ngModel)]="selectedAvailability"
      (change)="onAvailabilityChange($event)">
      <mat-radio-button [value]="availabilityFilter.total.field">
        {{availabilityFilter.total.key | translate}}
      </mat-radio-button>

      <mat-radio-button [value]="availabilityFilter.available.field">
        {{availabilityFilter.available.key | translate}}
      </mat-radio-button>
    </mat-radio-group>
  </fieldset>
</div>

<mat-accordion displayMode="flat" multi="true">
  <ng-container *ngIf="true">
    <mat-expansion-panel *ngIf="formatFilter?.values.length" [expanded]="true">
      <mat-expansion-panel-header collapsedHeight="36px" expandedHeight="36px" [tabIndex]="isSideBarOpen ? 0 : -1">
        {{formatFilter.label}}
        <button
          class="btn-icon-text"
          mat-flat-button
          [attr.aria-label]="'tooltip.info' | translate"
          appStopPropagation
          (click)="openExperiencesInfoDialog()"
          *ngIf="showExperiencesFeatures">
          <span class="odilo-icon" aria-hidden="true">info</span>
        </button>
      </mat-expansion-panel-header>

      <div class="mat-expansion-panel__list">
        <ng-container *ngFor="let item of getExpandedValues(traditionalFormatFilter.values)">
          <div class="expansion-panel__item" [class.selected]="item.selected"
               tabindex="0"
               (keydown.enter)="applyFilter(formatFilter.name, item.name)"
               (keydown.space)="applyFilter(formatFilter.name, item.name)"
               (click)="applyFilter(formatFilter.name, item.name)">
            <div class="wrapper">
              <span [className]="'format-icon ' + formatFilterInfoMap.get(item).className" aria-hidden="true"
                >{{ formatFilterInfoMap.get(item).icon }}</span
              >
              <span class="format-label-and-count">
                <span [innerHtml]="formatFilterInfoMap.get(item).label | translate"></span>
                <span class="count">{{ item.value }}</span>
              </span>
            </div>

            <span class="close odilo-icon">close</span>
          </div>
        </ng-container>

        <div class="mat-expansion-panel__list__nested" [class.collapsed]="!traditionalFormatFilter.expanded">
          <div *ngFor="let item of getCollapsedValues(traditionalFormatFilter.values)">
            <div
              class="expansion-panel__item"
              [class.selected]="item.selected"
              tabindex="0"
              (keydown.enter)="applyFilter(traditionalFormatFilter.name, item.name)"
              (keydown.space)="applyFilter(traditionalFormatFilter.name, item.name)"
              (click)="applyFilter(traditionalFormatFilter.name, item.name)"
              [tabIndex]="(isSideBarOpen && traditionalFormatFilter.expanded) ? 0 : -1">
              <div class="wrapper">
                <span [className]="'format-icon ' + formatFilterInfoMap.get(item).className" aria-hidden="true"
                  >{{ formatFilterInfoMap.get(item).icon }}</span
                >
                <span class="format-label-and-count">
                  <span [innerHtml]="formatFilterInfoMap.get(item).label | translate"></span>
                  <span class="count">{{ item.value }}</span>
                </span>
              </div>

              <span class="close odilo-icon">close</span>
            </div>
          </div>
        </div>
      </div>

      <span
        *ngIf="hasViewMore(traditionalFormatFilter.values)"
        class="mat-expansion-panel__more"
        [class.mat-expansion-panel__more--indented]="showFormatSeparator"
        (keydown.enter)="toggleValuesPanel(traditionalFormatFilter)"
        (keydown.space)="toggleValuesPanel(traditionalFormatFilter)"
        (click)="toggleValuesPanel(traditionalFormatFilter)"
        [tabIndex]="isSideBarOpen ? 0 : -1">
        <span class="odilo-icon" aria-hidden="true">{{traditionalFormatFilter.icon}}</span>
        <span class="expansion-panel-text">{{traditionalFormatFilter.action | translate}}</span>
      </span>

      <span
        *ngIf="shouldShowViewAll(traditionalFormatFilter)"
        class="mat-expansion-panel__more"
        [class.mat-expansion-panel__more--indented]="showFormatSeparator"
        (keydown.enter)="openViewAllDialog(traditionalFormatFilter)"
        (keydown.space)="openViewAllDialog(traditionalFormatFilter)"
        (click)="openViewAllDialog(traditionalFormatFilter)"
        [@expandAnimation]="shouldShowViewAll(traditionalFormatFilter)"
        [tabIndex]="isSideBarOpen ? 0 : -1">
        <span class="odilo-icon" aria-hidden="true">add</span>
        <span class="expansion-panel-text">{{'general.viewAll' | translate}}</span>
      </span>

      <mat-divider *ngIf="showFormatSeparator"></mat-divider>

      <div class="mat-expansion-panel__list">
        <ng-container *ngFor="let item of getExpandedValues(physicalFilterKeys.values)">
          <div class="expansion-panel__item" [class.selected]="item.selected"
               tabindex="0"
               (keydown.enter)="applyFilter(formatFilter.name, item.name)"
               (keydown.space)="applyFilter(formatFilter.name, item.name)"
               (click)="applyFilter(formatFilter.name, item.name)">
            <div class="wrapper">
              <span [className]="'format-icon ' + formatFilterInfoMap.get(item).className" aria-hidden="true"
                >{{ formatFilterInfoMap.get(item).icon }}</span
              >
              <span class="format-label-and-count">
                <span [innerHtml]="formatFilterInfoMap.get(item).label | translate"></span>
                <span class="count">{{ item.value }}</span>
              </span>
            </div>

            <span class="close odilo-icon">close</span>
          </div>
        </ng-container>

        <div class="mat-expansion-panel__list__nested" [class.collapsed]="!physicalFilterKeys.expanded">
          <div *ngFor="let item of getCollapsedValues(physicalFilterKeys.values)">
            <div
              class="expansion-panel__item"
              [class.selected]="item.selected"
              tabindex="0"
              (keydown.enter)="applyFilter(physicalFilterKeys.name, item.name)"
              (keydown.space)="applyFilter(physicalFilterKeys.name, item.name)"
              (click)="applyFilter(physicalFilterKeys.name, item.name)"
              [tabIndex]="(isSideBarOpen && physicalFilterKeys.expanded) ? 0 : -1">
              <div class="wrapper">
                <span [className]="'format-icon ' + formatFilterInfoMap.get(item).className" aria-hidden="true"
                  >{{ formatFilterInfoMap.get(item).icon }}</span
                >
                <span class="format-label-and-count">
                  <span [innerHtml]="formatFilterInfoMap.get(item).label | translate"></span>
                  <span class="count">{{ item.value }}</span>
                </span>
              </div>

              <span class="close odilo-icon">close</span>
            </div>
          </div>
        </div>
      </div>

      <span
        *ngIf="physicalFilterKeys.values.length > MAX_FILTER_VALUES"
        class="mat-expansion-panel__more mat-expansion-panel__more--indented"
        (keydown.enter)="toggleValuesPanel(physicalFilterKeys)"
        (keydown.space)="toggleValuesPanel(physicalFilterKeys)"
        (click)="toggleValuesPanel(physicalFilterKeys)"
        [tabIndex]="isSideBarOpen ? 0 : -1">
        <span class="odilo-icon" aria-hidden="true">{{physicalFilterKeys.icon}}</span>
        <span class="expansion-panel-text">{{physicalFilterKeys.action | translate}}</span>
      </span>

      <span
        *ngIf="shouldShowViewAll(physicalFilterKeys)"
        class="mat-expansion-panel__more mat-expansion-panel__more--indented"
        (keydown.enter)="openViewAllDialog(physicalFilterKeys)"
        (keydown.space)="openViewAllDialog(physicalFilterKeys)"
        (click)="openViewAllDialog(physicalFilterKeys)"
        [@expandAnimation]="shouldShowViewAll(physicalFilterKeys)"
        [tabIndex]="isSideBarOpen ? 0 : -1">
        <span class="odilo-icon" aria-hidden="true">add</span>
        <span class="expansion-panel-text">{{'general.viewAll' | translate}}</span>
      </span>

      <mat-divider *ngIf="showPhysicalFormatSeparator"></mat-divider>

      <div class="mat-expansion-panel__list">
        <ng-container *ngFor="let item of getExpandedValues(experiencesFormatFilter.values)">
          <div
            class="expansion-panel__item"
            [class.selected]="item.selected"
            tabindex="0"
            (click)="applyFilter(formatFilter.name, item.name)">
            <div class="wrapper">
              <span [className]="'format-icon ' + formatFilterInfoMap.get(item).className" aria-hidden="true"
                >{{ formatFilterInfoMap.get(item).icon }}</span
              >
              <span class="format-label-and-count">
                <span [innerHtml]="formatFilterInfoMap.get(item).label | translate"></span>
                <span class="count">{{ item.value }}</span>
              </span>
            </div>

            <span class="close odilo-icon">close</span>
          </div>
        </ng-container>

        <div class="mat-expansion-panel__list__nested" [class.collapsed]="!experiencesFormatFilter.expanded">
          <div *ngFor="let item of getCollapsedValues(experiencesFormatFilter.values)">
            <div
              class="expansion-panel__item"
              [class.selected]="item.selected"
              tabindex="0"
              (keydown.enter)="applyFilter(experiencesFormatFilter.name, item.name)"
              (keydown.space)="applyFilter(experiencesFormatFilter.name, item.name)"
              (click)="applyFilter(experiencesFormatFilter.name, item.name)"
              [tabIndex]="(isSideBarOpen && experiencesFormatFilter.expanded) ? 0 : -1">
              <div class="wrapper">
                <span [className]="'format-icon ' + formatFilterInfoMap.get(item).className" aria-hidden="true"
                  >{{ formatFilterInfoMap.get(item).icon }}</span
                >
                <span class="format-label-and-count">
                  <span [innerHtml]="formatFilterInfoMap.get(item).label | translate"></span>
                  <span class="count">{{ item.value }}</span>
                </span>
              </div>

              <span class="close odilo-icon">close</span>
            </div>
          </div>
        </div>
      </div>

      <span
        *ngIf="experiencesFormatFilter.values.length > MAX_FILTER_VALUES"
        class="mat-expansion-panel__more mat-expansion-panel__more--indented"
        (keydown.enter)="toggleValuesPanel(experiencesFormatFilter)"
        (keydown.space)="toggleValuesPanel(experiencesFormatFilter)"
        (click)="toggleValuesPanel(experiencesFormatFilter)"
        [tabIndex]="isSideBarOpen ? 0 : -1">
        <span class="odilo-icon" aria-hidden="true">{{experiencesFormatFilter.icon}}</span>
        <span class="expansion-panel-text">{{experiencesFormatFilter.action | translate}}</span>
      </span>

      <span
        *ngIf="shouldShowViewAll(experiencesFormatFilter)"
        class="mat-expansion-panel__more mat-expansion-panel__more--indented"
        (keydown.enter)="openViewAllDialog(experiencesFormatFilter)"
        (keydown.space)="openViewAllDialog(experiencesFormatFilter)"
        (click)="openViewAllDialog(experiencesFormatFilter)"
        [@expandAnimation]="shouldShowViewAll(experiencesFormatFilter)"
        [tabIndex]="isSideBarOpen ? 0 : -1">
        <span class="odilo-icon" aria-hidden="true">add</span>
        <span class="expansion-panel-text">{{'general.viewAll' | translate}}</span>
      </span>
    </mat-expansion-panel>
  </ng-container>

  <ng-container *ngFor="let filter of filters">
    <mat-expansion-panel *ngIf="!isBiblioHoFilter(filter) && filter.values.length" [expanded]="true">
      <mat-expansion-panel-header collapsedHeight="36px" expandedHeight="36px">
        {{filter.label}}
      </mat-expansion-panel-header>

      <div class="mat-expansion-panel__list">
        <ng-container *ngFor="let item of getFilterExpandedValues(filter)">
          <div
            class="expansion-panel__item"
            [class.selected]="item.selected"
            tabindex="0"
            (keydown.enter)="applyHoFilter(filter.name, item)"
            (keydown.space)="applyHoFilter(filter.name, item)"
            (click)="applyHoFilter(filter.name, item)"
            [tabIndex]="isSideBarOpen ? 0 : -1">
            <div class="wrapper">
              <span [innerHtml]="adaptAndTranslate(filter, item)"></span>
              <span
                *ngIf="item.value !== 0"
                class="count"
                [attr.aria-label]="item.value + ' ' + ('general.items' | translate)"
                >{{item.value}}</span
              >
            </div>

            <span class="close odilo-icon">close</span>
          </div>
        </ng-container>

        <div class="mat-expansion-panel__list__nested" [class.collapsed]="!filter.expanded">
          <div *ngFor="let item of getFilterCollapsedValues(filter)">
            <div
              class="expansion-panel__item"
              [class.selected]="item.selected"
              tabindex="0"
              (keydown.enter)="applyHoFilter(filter.name, item)"
              (keydown.space)="applyHoFilter(filter.name, item)"
              (click)="applyHoFilter(filter.name, item)"
              [tabIndex]="(isSideBarOpen && filter.expanded) ? 0 : -1">
              <div class="wrapper">
                <span [innerHtml]="adaptAndTranslate(filter, item)"></span>
                <span *ngIf="item.value !== 0" class="count">{{item.value}}</span>
              </div>

              <span class="close odilo-icon">close</span>
            </div>
          </div>
        </div>
      </div>

      <span
        *ngIf="hasViewMoreFilter(filter)"
        class="mat-expansion-panel__more"
        (keydown.enter)="toggleValuesPanel(filter)"
        (keydown.space)="toggleValuesPanel(filter)"
        (click)="toggleValuesPanel(filter)"
        [tabIndex]="isSideBarOpen ? 0 : -1">
        <span class="odilo-icon" aria-hidden="true">{{filter.icon}}</span>
        <span class="expansion-panel-text">{{filter.action | translate}}</span>
      </span>

      <span
        *ngIf="shouldShowViewAllFilter(filter)"
        class="mat-expansion-panel__more"
        (keydown.enter)="openViewAllDialogFilter(filter)"
        (keydown.space)="openViewAllDialogFilter(filter)"
        (click)="openViewAllDialogFilter(filter)"
        [@expandAnimation]="shouldShowViewAllFilter(filter)"
        [tabIndex]="isSideBarOpen ? 0 : -1">
        <span class="odilo-icon" aria-hidden="true">add</span>
        <span class="expansion-panel-text">{{'general.viewAll' | translate}}</span>
      </span>
    </mat-expansion-panel>
  </ng-container>
</mat-accordion>
